import { deleteCustomUnit, getCustomUnits } from 'api/v2/revenues';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { RevenuesCacheKeys } from 'types/cacheKeys.types';
import { defaultInvoiceItemUnitEnum } from 'types/invoice.types';

const useRevenuesUnits = () => {
  const { t } = useTranslation();

  const { data: customUnits, refetch: refetchUnits } = useQuery(
    [RevenuesCacheKeys.CustomUnits],
    () => getCustomUnits(),
    {
      select: (units) => units.map((unit) => ({ label: unit, value: unit })),
    },
  );

  const deleteUnitMutation = useMutation(
    (unitToDelete: string) => deleteCustomUnit(unitToDelete),
    {
      onSuccess: () => {
        refetchUnits();
      },
    },
  );

  const defaultUnits: { label: string; value: string; isDefault?: boolean }[] =
    [
      {
        label: t('invoice.form.items'),
        value: defaultInvoiceItemUnitEnum.items,
        isDefault: true,
      },
      {
        label: t('invoice.form.hours'),
        value: defaultInvoiceItemUnitEnum.hours,
        isDefault: true,
      },
      {
        label: t('invoice.form.days'),
        value: defaultInvoiceItemUnitEnum.days,
        isDefault: true,
      },
      {
        label: t('invoice.form.km'),
        value: defaultInvoiceItemUnitEnum.km,
        isDefault: true,
      },
    ];

  const options = Array.isArray(customUnits)
    ? defaultUnits.concat(customUnits)
    : defaultUnits;

  return {
    options,
    defaultUnits,
    deleteUnitMutation,
  };
};

export default useRevenuesUnits;
